
import React from 'react';
import { 
  SmartphoneIcon, 
  GlobeIcon, 
  MonitorIcon, 
  RocketIcon,
  HeartPulseIcon,
  UsersIcon,
  CheckIcon
} from 'lucide-react';

interface SelectedOptionsProps {
  platforms: string[];
  appType?: string;
  features: string[];
  userVolume?: string;
  maintenance?: number;
}

const SelectedOptions: React.FC<SelectedOptionsProps> = ({
  platforms,
  appType,
  features,
  userVolume,
  maintenance
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium mb-2">Platforms</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {platforms.map((platform) => (
            <div key={platform} className="bg-primary/10 text-primary rounded-md py-1 px-3 text-sm flex items-center gap-1">
              {platform === 'iOS' || platform === 'Android' ? <SmartphoneIcon className="h-3.5 w-3.5" /> : 
               platform === 'Web' ? <GlobeIcon className="h-3.5 w-3.5" /> : 
               <MonitorIcon className="h-3.5 w-3.5" />}
              {platform}
            </div>
          ))}
        </div>
      </div>
      
      {appType && (
        <div>
          <h3 className="text-lg font-medium mb-2">App Type</h3>
          <div className="bg-primary/10 text-primary rounded-md py-1 px-3 text-sm inline-flex items-center gap-1">
            <RocketIcon className="h-3.5 w-3.5" />
            {appType}
          </div>
        </div>
      )}
      
      {features.length > 0 && (
        <div>
          <h3 className="text-lg font-medium mb-2">Selected Features</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
            {features.map((feature) => (
              <div key={feature} className="bg-accent text-accent-foreground rounded-md py-1 px-3 text-sm flex items-center gap-1">
                <CheckIcon className="h-3.5 w-3.5" />
                {feature === 'auth' ? 'Authentication' : 
                 feature === 'logo' ? 'Logo Design' :
                 feature === 'customUI' ? 'Custom UI/UX' :
                 feature === 'chat' ? 'Real-time Chat' :
                 feature === 'payments' ? 'Payments' :
                 feature === 'gps' ? 'GPS/Maps' :
                 feature === 'backend' ? 'Backend/DB' :
                 feature === 'adminPanel' ? 'Admin Panel' :
                 feature === 'apiIntegration' ? 'API Integration' :
                 feature === 'push' ? 'Push Notifications' :
                 feature === 'offline' ? 'Offline Mode' :
                 'Cloud Sync'}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {userVolume && (
        <div>
          <h3 className="text-lg font-medium mb-2">User Volume</h3>
          <div className="bg-primary/10 text-primary rounded-md py-1 px-3 text-sm inline-flex items-center gap-1">
            <UsersIcon className="h-3.5 w-3.5" />
            {userVolume === 'small' ? 'Small (Up to 100 users)' : 
             userVolume === 'medium' ? 'Medium (Up to 1,000 users)' :
             userVolume === 'large' ? 'Large (Up to 100,000 users)' :
             'Enterprise (100,000+ users)'}
          </div>
        </div>
      )}
      
      {maintenance && (
        <div>
          <h3 className="text-lg font-medium mb-2">Maintenance Plan</h3>
          <div className="bg-primary/10 text-primary rounded-md py-1 px-3 text-sm inline-flex items-center gap-1">
            <HeartPulseIcon className="h-3.5 w-3.5" />
            {maintenance} Month Maintenance
          </div>
        </div>
      )}
    </div>
  );
};

export default SelectedOptions;
